exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span.multiselect__option--selected{pointer-events:none!important}.multiselect{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3bb2dcba!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Multiselect.vue
// module id = 876
// module chunks = 2